import { SidebarMenuBadge } from '@/components/ui/sidebar';
import { useConversationTabCounts } from '@/features/conversations/api';

/** How many conversations are waiting on a reply from us (0 while loading). */
export function useNeedsReplyCount(): number {
  const { counts } = useConversationTabCounts();
  return counts?.needs_reply ?? 0;
}

export const formatNavCount = (count: number): string =>
  count > 99 ? '99+' : String(count);

/**
 * The count on the Inbox item in the sidebar: people who messaged last and are
 * still waiting on us. Renders nothing at zero, so a quiet inbox stays quiet.
 */
export function InboxNavBadge() {
  const count = useNeedsReplyCount();
  if (count === 0) return null;
  return (
    <SidebarMenuBadge
      role="status"
      aria-label={`${count} waiting for a reply`}
      // The base badge darkens its text on hover/active; keep it white.
      className="bg-primary text-primary-foreground peer-hover/menu-button:text-primary-foreground peer-data-[active=true]/menu-button:text-primary-foreground"
    >
      {formatNavCount(count)}
    </SidebarMenuBadge>
  );
}
